import classes from "./filterButton.module.css";

const FliterButton = (props) => {
  return (
    <div className={`${classes.container} ${props.selected && classes.active}`}>
      {/* {props.icon && <img className={classes.icon} src={props.icon} alt="" />} */}
      <h1 className={classes.title}>{props.title}</h1>
    </div>
  );
};

export default FliterButton;
